import { compact } from 'lodash'
import type { FilterType } from 'app/components/ui/table-filters/use-filters-container'
import {
  type FilterObject,
  type FilterableColumn,
  getReadableOperator,
  isFilterOperator,
  toFilterValue,
} from 'app/filter.utils'

/**
 * Stored rules are bare `{ attribute, operator, value }`; the builder wants the column's
 * display name and type beside them. A rule on an attribute this page cannot filter is
 * dropped rather than shown as a dead row.
 */
export function seedFilters(
  source: Pick<FilterObject, `attribute` | `operator` | `value`>[],
  columns: FilterableColumn[],
): FilterType[] {
  return compact(
    source.map((rule) => {
      const column = columns.find((candidate) => candidate.attribute === rule.attribute)
      if (!column || !isFilterOperator(rule.operator)) return undefined
      return {
        ...column,
        value: toFilterValue(rule.value),
        operator: rule.operator,
        name: column.displayName,
        displayOperator: getReadableOperator(rule.operator, column.type),
      }
    }),
  )
}
